import { Controller } from "@hotwired/stimulus"

// Side drawer or dialog on a native <dialog>: opens once its turbo frame has loaded (a request
// clicked in a list, the form to contact a gallery), closes on Escape, the ✕ or a click beside
// the panel. The dialog keeps the focus inside and gives it back to the clicked link.
export default class extends Controller<HTMLDialogElement> {
  connect() {
    this.element.addEventListener("close", this._reset)
  }

  disconnect() {
    this.element.removeEventListener("close", this._reset)
  }

  open() {
    if (this.element.open) return
    this.element.showModal()
    requestAnimationFrame(() => this.element.classList.add("is-open"))   // from off-screen: the panel slides in
  }

  // Slides out, then closes
  close() {
    this.element.classList.remove("is-open")
    const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches
    window.setTimeout(() => this.element.close(), reduced ? 0 : 320)
  }

  closeOnBackdrop(event: MouseEvent) {
    if (event.target === this.element) this.close()
  }

  // Also after Escape. Forgetting the frame's address lets the same request open again.
  _reset = () => {
    this.element.classList.remove("is-open")
    this.element.querySelector("turbo-frame")?.removeAttribute("src")
  }
}
